export default {
  detail: state => id => state.news.find(item => item.id == id)
}